<ion-header [translucent]="true">

    <ion-toolbar class="ion-padding-end">
        <ion-title slot="start">{{Title}}</ion-title>
        <ion-button style="margin-right: -16px;" fill="clear" color="dark" shape="round" slot="end" (click)="Close()">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
    </ion-toolbar>

    <ion-toolbar>
        <ion-segment [value]="Mode" (ionChange)="OnChangeMode($event)">

            <ion-segment-button [value]="EnumHouseholdModalMode.Members" layout="icon-start">
                <ion-icon name="people-outline"></ion-icon>
                <ion-label i18n=":@@associate_household.members_title">Membros</ion-label>
            </ion-segment-button>

            <ion-segment-button [value]="EnumHouseholdModalMode.Associate" layout="icon-start">
                <ion-icon name="card-outline"></ion-icon>
                <ion-label i18n=":@@associate_household.associate_title">Associar</ion-label>
            </ion-segment-button>

        </ion-segment>
    </ion-toolbar>

</ion-header>

<ion-content class="ion-padding padding-horizontal">

    <!-- MEMBROS ATUAIS -->
    <ng-container *ngIf="Mode === EnumHouseholdModalMode.Members">

        <ion-grid class="ion-no-padding ion-no-margin table">

            <ion-row class="table-header">
                <ion-col class="flex-align-center" i18n=":@@associate_household.member_table_name">Nome</ion-col>
                <ion-col size="2" class="flex-align-center" i18n=":@@associate_household.member_table_card">Nº Cartão</ion-col>
                <ion-col size="2" class="flex-align-center" i18n=":@@associate_household.member_table_status">Estado</ion-col>
                <ion-col size="2" class="flex-align-center ion-hide-xl-down" i18n=":@@associate_household.member_table_date">Registo</ion-col>
                <ion-col class="flex-align-center buttons-size-3"></ion-col>
            </ion-row>

            <ng-container *ngFor="let group of Groups">

                <ion-row class="table-body table-inner-header household-group-header">
                    <ion-col class="flex-align-center">{{group?.Label}}</ion-col>
                </ion-row>

                <ion-row class="table-body with-button-opacity" *ngFor="let item of group?.Members">

                    <ion-col class="flex-align-center">
                        {{item?.PersonalData?.Name}}
                    </ion-col>

                    <ion-col size="2" class="flex-align-center">
                        {{CardNumber(item?.WalletCard?.Number)}}
                    </ion-col>

                    <ion-col size="2" class="flex-align-center">
                        {{item?.Status?.Name || '--'}}
                    </ion-col>

                    <ion-col size="2" class="flex-align-center ion-hide-xl-down">
                        <date-tooltip [date]="item?.Status?.RegistDate"></date-tooltip>
                    </ion-col>

                    <ion-col class="flex-justify-end buttons-size-3">
                        <ion-button *ngIf="!IsProfileMember(item)" fill="clear" size="small"
                            (click)="OnViewMember($event, item)"
                            [actionsPermissions]="EnumActionsPermissions.CANACCESSALL">
                            <ion-icon name="eye-outline" slot="icon-only"></ion-icon>
                        </ion-button>

                        <!-- nos agregados que o consumidor não gere a estrela só marca
                             quem é o responsável: sem acção e sem estrela vazia -->
                        <ion-button
                            *ngIf="IsHouseHoldMemberAccepted(item) && (group?.IsProfileMain || item?.IsMain)"
                            fill="clear" size="small" [color]="item?.IsMain ? 'warning' : 'medium'"
                            [disabled]="!group?.IsProfileMain"
                            [class.star-readonly]="!group?.IsProfileMain"
                            [actionsPermissions]="EnumActionsPermissions.CREATEANDEDIT"
                            (click)="OnToggleMain($event, item)"
                            [title]="group?.IsProfileMain
                                ? (item?.IsMain ? 'Retirar responsável do agregado' : 'Definir como responsável do agregado')
                                : (item?.IsMain ? 'Responsável do agregado' : '')">
                            <ion-icon [name]="item?.IsMain ? 'star' : 'star-outline'" slot="icon-only"></ion-icon>
                        </ion-button>

                        <ion-button *ngIf="group?.IsProfileMain && IsHouseHoldMemberActive(item)"
                            fill="clear" size="small" color="danger"
                            [actionsPermissions]="EnumActionsPermissions.CREATEANDEDIT"
                            (click)="OnRemoveMember($event, item)"
                            title="Cancelar associação ao agregado">
                            <ion-icon name="close-outline" slot="icon-only"></ion-icon>
                        </ion-button>
                    </ion-col>

                </ion-row>

            </ng-container>

            <ion-row *ngIf="!Groups || Groups?.length == 0">
                <ion-col>
                    <no-items description="Sem dados"></no-items>
                </ion-col>
            </ion-row>

        </ion-grid>

    </ng-container>

    <!-- ASSOCIAR NOVO CARTÃO -->
    <ng-container *ngIf="Mode === EnumHouseholdModalMode.Associate">

        <!-- PASSO 1 — destino -->
        <ion-card class="ion-no-margin step-card">
            <ion-card-header>
                <ion-card-title>
                    <span class="step-badge">1</span>
                    <span i18n=":@@associate_household.target_hint">Escolha o agregado de destino</span>
                </ion-card-title>
            </ion-card-header>

            <ion-card-content>

                <!-- há pelo menos 1 agregado existente: primeiro escolhe-se o modo —
                     associar a um existente ou criar um novo, nunca os dois misturados
                     numa só lista. Campo (select ou nome) na linha de baixo, não ao lado. -->
                <div class="household-target-block" *ngIf="TargetGroups.length > 0">

                    <div class="household-mode">

                        <ion-button [fill]="!IsNewHouseHold ? 'solid' : 'outline'"
                            [color]="!IsNewHouseHold ? 'primary' : 'medium'" (click)="OnSelectHouseHoldMode(false)">
                            <ion-icon slot="start" name="people-outline"></ion-icon>
                            <span i18n=":@@associate_household.existing_household">Agregado existente</span>
                        </ion-button>

                        <ion-button [fill]="IsNewHouseHold ? 'solid' : 'outline'"
                            [color]="IsNewHouseHold ? 'primary' : 'medium'" (click)="OnSelectHouseHoldMode(true)">
                            <ion-icon slot="start" name="add-outline"></ion-icon>
                            <span i18n=":@@associate_household.new_household">Novo agregado</span>
                        </ion-button>

                    </div>

                    <ion-item *ngIf="!IsNewHouseHold" class="full target-picker-select" lines="none" fill="outline">
                        <ion-label position="stacked" i18n=":@@associate_household.target_label">Agregado</ion-label>

                        <app-select-search class="outline" [interface]="'popover'" [value]="SelectedHouseHoldId"
                            (selectionChange)="OnSelectTarget($event)" style="max-width: calc(100% - 12px);">

                            <app-select-search-option *ngFor="let group of TargetGroups" [value]="group.IdHouseHold">
                                {{group?.Label}}
                            </app-select-search-option>

                        </app-select-search>
                    </ion-item>

                    <ion-item *ngIf="IsNewHouseHold" class="full new-household-name" lines="full">
                        <ion-label position="stacked" i18n=":@@associate_household.new_household_name">Nome do agregado
                            (opcional)</ion-label>
                        <ion-input [value]="NewHouseHoldName"
                            (ionInput)="NewHouseHoldName = $event.detail.value"></ion-input>
                    </ion-item>

                </div>

                <!-- sem agregados existentes: o destino só pode ser um novo, sem toggle a mostrar -->
                <ion-item *ngIf="TargetGroups.length == 0" class="full new-household-name standalone" lines="full">
                    <ion-label position="stacked" i18n=":@@associate_household.new_household_name">Nome do agregado
                        (opcional)</ion-label>
                    <ion-input [value]="NewHouseHoldName" (ionInput)="NewHouseHoldName = $event.detail.value"></ion-input>
                </ion-item>

            </ion-card-content>
        </ion-card>

        <!-- PASSO 2 — cartão + confirmação -->
        <ion-card class="ion-no-margin ion-margin-top step-card">
            <ion-card-header>
                <ion-card-title>
                    <span class="step-badge">2</span>
                    <span i18n=":@@associate_household.search_hint">Procure o membro</span>
                </ion-card-title>
            </ion-card-header>

            <ion-card-content>

                <!-- mesmo design da pesquisa de consumidor em /merchants/movements (novo consumo):
                     ion-item com label dinâmica, searchbar + botão de pesquisa numa linha, tipo
                     de campo (NIF/Cartão) centrado por baixo -->
                <form [formGroup]="SearchForm" class="full search-box">

                    <ion-item class="full" lines="full">
                        <ion-label position="stacked">
                            {{ IsSearchType(EnumConsumerCardSearchField.CardNumber)
                            ? 'Número Cartão'
                            : 'NIF' }}
                        </ion-label>

                        <ion-grid class="full ion-no-padding">

                            <ion-row class="full ion-no-padding">

                                <ng-container [ngSwitch]="SearchForm.get('SearchType').value">

                                    <ion-col *ngSwitchCase="EnumConsumerCardSearchField.CardNumber">
                                        <ion-searchbar class="ion-no-padding" placeholder="procurar nº cartão"
                                            formControlName="CardNumber" (ionClear)="OnClearResults()"
                                            (ionInput)="OnCleanCardNumberInput($event)"
                                            (keyup.enter)="OnSearch($event)"></ion-searchbar>
                                    </ion-col>

                                    <ion-col *ngSwitchDefault>
                                        <ion-searchbar class="ion-no-padding" placeholder="procurar NIF"
                                            formControlName="VatNumber" (ionClear)="OnClearResults()"
                                            (keyup.enter)="OnSearch($event)"></ion-searchbar>
                                    </ion-col>

                                </ng-container>

                                <ion-col class="search-action-col">
                                    <ion-button fill="solid" color="primary" title="Pesquisar"
                                        (click)="OnSearch($event)">
                                        <ion-icon slot="icon-only" name="search-outline"></ion-icon>
                                    </ion-button>
                                </ion-col>

                            </ion-row>

                            <ion-row class="full ion-no-padding ion-padding-vertical">
                                <ion-col class="ion-text-center">

                                    <ion-button
                                        [fill]="IsSearchType(EnumConsumerCardSearchField.VatNumber) ? 'solid' : 'outline'"
                                        [color]="IsSearchType(EnumConsumerCardSearchField.VatNumber) ? 'primary' : 'medium'"
                                        (click)="OnChangeSearchType($event, EnumConsumerCardSearchField.VatNumber)">
                                        <ion-icon slot="start" name="person-outline"></ion-icon>
                                        NIF
                                    </ion-button>

                                    <ion-button
                                        [fill]="IsSearchType(EnumConsumerCardSearchField.CardNumber) ? 'solid' : 'outline'"
                                        [color]="IsSearchType(EnumConsumerCardSearchField.CardNumber) ? 'primary' : 'medium'"
                                        (click)="OnChangeSearchType($event, EnumConsumerCardSearchField.CardNumber)">
                                        <ion-icon slot="start" name="card-outline"></ion-icon>
                                        Nº Cartão
                                    </ion-button>

                                </ion-col>
                            </ion-row>

                        </ion-grid>
                    </ion-item>

                </form>

                <ion-grid class="ion-no-padding ion-no-margin table" *ngIf="SearchData?.length > 0">

                    <ion-row class="table-header">
                        <ion-col size="1" class="flex-align-center flex-justify-center"></ion-col>
                        <ion-col class="flex-align-center" i18n=":@@associate_household.search_table_name">Nome</ion-col>
                        <ion-col size="3" class="flex-align-center" i18n=":@@associate_household.search_table_card">Nº
                            Cartão</ion-col>
                    </ion-row>

                    <ion-row class="table-body clickable" *ngFor="let item of SearchData"
                        [class.row-selected]="IsSelectedCard(item)" [class.row-disabled]="IsAlreadyMember(item)"
                        [title]="IsAlreadyMember(item) ? 'Já pertence a este agregado' : ''"
                        (click)="OnSelectCard(item)">

                        <ion-col size="1" class="flex-align-center flex-justify-center">
                            <ion-icon
                                [name]="IsAlreadyMember(item) ? 'checkmark-done-outline' : (IsSelectedCard(item) ? 'checkmark-circle' : 'ellipse-outline')"
                                [color]="IsSelectedCard(item) ? 'primary' : 'medium'"></ion-icon>
                        </ion-col>

                        <ion-col class="flex-align-center">
                            {{item?.Name || '--'}}
                            <ion-chip *ngIf="IsAlreadyMember(item)" class="already-member-chip" color="medium"
                                i18n=":@@associate_household.already_member">Já pertence ao agregado</ion-chip>
                        </ion-col>

                        <ion-col size="3" class="flex-align-center">{{CardNumber(item?.CardNumber)}}</ion-col>

                    </ion-row>

                </ion-grid>

                <no-items *ngIf="SearchData?.length == 0 && !HasSearched" icon="search-outline"
                    [description]="EmptyDescription"></no-items>

                <no-items *ngIf="SearchData?.length == 0 && HasSearched" description="Sem resultados"></no-items>

                <div class="confirm-associate">
                    <ion-button fill="solid" color="primary" [disabled]="!SelectedCardId"
                        (click)="OnConfirmAssociate($event)" i18n=":@@associate_household.submit">Associar membro
                    </ion-button>
                </div>

            </ion-card-content>
        </ion-card>

    </ng-container>

</ion-content>
